<template>
	<div>
		<!--FILTRI - ESTENSIONI-->
		<div v-if="extensionsFilter" class="form-group">
			<h6 class="bg-light p-2 text-bold">
				<span>{{ $t('Filter by extensions') }} ({{ $t('Optional') }})</span>
			</h6>
			<input type="checkbox" v-model="useExtensionsFilter" :data-caption="$t('Use extensions filter')" data-role="checkbox" />

			<div class="d-flex flex-column">
				<input name='includeExcludeExtensions' type='radio' data-role='radio' :data-caption="$t('Exclude specified extensions')" v-model="options.extensionsFilterAction" :value="0" :disabled="!useExtensionsFilter">
				<input name='includeExcludeExtensions' type='radio' data-role='radio' :data-caption="$t('Include only specified extensions')" v-model="options.extensionsFilterAction" :value="1" :disabled="!useExtensionsFilter">
			</div>

			<div class="cell-12">
				<label class="text-bold" :disabled="!useExtensionsFilter">{{ $t("Extensions :") }}</label>
				<select v-model="specifiedExtensionsArray" multiple data-role="select" class="input" :disabled="!useExtensionsFilter">
					<optgroup v-for="(extensionsList, extensionsCategory) in fileExtensions" :label="$t(extensionsCategory)" :key="extensionsCategory">
						<option v-for="extension in extensionsList" :value="extension">{{ extension }}</option>
					</optgroup>
				</select>
			</div>
		</div>
		<br>

		<!--FILTRI - DIMENSIONE FILE-->
		<div v-if="fileSizeFilter" class="form-group">
			<h6 class="bg-light p-2 text-bold">
				<span>{{ $t('Filter by file size') }} ({{ $t('Optional') }})</span>
			</h6>

			<input type="checkbox" v-model="options.useFileSizeFilter" :data-caption="$t('Use file size filter')" data-role="checkbox" />

			<div class="w-100 d-flex flex-align-center">
				<select v-model="options.fileSizeFilterAction" :disabled="!options.useFileSizeFilter" class="input input-small mr-2 h-100 w-40">
					<option v-for="(value, index) in $root.selectValues.fileSizeFilterAction" :value="index" v-bind:key="index">
						{{ $t(value) }}
					</option>

				</select>

				<select v-model="options.fileSizeFilterCompare" :disabled="!options.useFileSizeFilter" class="input input-small mr-2 h-100 w-40">
					<option v-for="(value, index) in $root.selectValues.fileSizeFilterCompare" :value="index" v-bind:key="index">
						{{ $t(value) }}
					</option>
				</select>

				<input type="number" v-number v-range="{ min: 1, max: 999999 }" v-model.number="options.fileSize" :disabled="!options.useFileSizeFilter" class="input text-right mr-2 w-25" />
				<span> MB</span>
			</div>
		</div>

		<div v-if="exclusions" class="form-group">
			<h6 class="text-bold">
				<span>{{ $t('Exclusions') }} ({{ $t('Optional') }})</span>
			</h6>
		</div>

		<div v-if="exclusions" class="form-group">{{ $t("Click on an item to select subfolders or files to exclude") }}</div>
		<!--VISUALIZZAZIONE DEGLI ELEMENTI SELEZIONATI-->
		<div v-if="exclusions" class="form-group">
			<label class="text-bold">{{ $t("Selected items") }}</label>
			<div class="row">
				<select class="input w-50" v-model="mainNodeSelected">
					<option v-for="node in mainNodes.filter(n => !n.type.isFile())" :key="node.path" :value="node">{{ node.path }}</option>
				</select>
				<button @click="openFileSystemSidebarFrom()" class="button secondary ml-2" :disabled="mainNodeSelected == null">{{ $t("Select items to exclude") }}</button>
			</div>

			<!--LISTA-->
			<!--<ul v-for="node in mainNodes.filter(n => !n.type.isFile())" :id="node.path" class="bd-black border border-2 my-2 p-2 d-none">
				<li style="list-style-type: none" class="c-pointer">
					<div @click="openFileSystemSidebarFrom()">
						<span class="text-bold">{{ $t("Copy the entire folder '{0}' except", { 0: node.path }) }} :</span>
					</div>
					<ul :title="node.path" class="bd-gray border border-1 my-2 overflow p-2 text-small" style="max-height:200px;"></ul>
				</li>
			</ul>-->

			<!--TABELLA-->
			<table v-for="node in mainNodes.filter(n => !n.type.isFile())" :mainNodePath="node.path" class="striped table compact w-100 bg-white border my-4 p-2 d-none">
				<thead class="mb-0" style="border-bottom: 2px solid #e4e4e4;">
					<tr>
						<th class="text-bold">{{ $t("Copy the entire folder '{0}' except", { 0: node.path }) }} :</th>
					</tr>
				</thead>
				<tbody :mainNodePath="node.path" html=""></tbody>
			</table>
		</div>



		<!--COMPRESSIONE ZIP-->
		<div v-if="zipCompression">
			<div class="form-group">
				<h6 class="text-bold">
					<span>{{ $t('Backup compression') }} ({{ $t('Optional') }})</span>
				</h6>
			</div>
			<div class="form-group">
				<input type="checkbox" v-model="options.useArchiveCompression" data-role="checkbox" :data-caption="$t('Enable compression')" />
				<br />
			</div>

			<div class="form-group d-flex flex-justify-between" :disabled="!options.useArchiveCompression">
				<div>
					<label>{{ $t("Archive type") }}</label>
					<select class="input" v-model="options.archiveType">
						<option v-for="(value, index) in $root.selectValues.archiveTypes" :value="index" v-bind:key="index">
							{{ $t(value) }}
						</option>
					</select>
				</div>
				<!--
                09/09/2024 : Al momento si considera solo il percorso completo (options.pathsInArchive = 1) all'interno del file zip.
                Se si vorranno implementare altre modalità, basta attivare questo div
                
                <div class="d-none">
                    <label>{{ $t("Paths in archive") }}</label>
                    <select class="input" v-model="options.pathsInArchive">
                        <option v-for="(value, index) in $root.selectValues.pathsInArchive" :value="index"
                            v-bind:key="index">{{ $t(value) }}
                        </option>
                    </select>
                </div>-->
			</div>


			<div class="form-group" :disabled="!options.useArchiveCompression">
				<input type="checkbox" v-model="options.useArchiveFileCustomName" data-role="checkbox" />
				<label>{{ $t("Give the archive file a custom name") }}</label>
				<br />
				<input type="text" class="input" v-model="options.archiveFileCustomName" :disabled="!options.useArchiveFileCustomName" required v-fsitem />
			</div>

			<div class="form-group" :disabled="!options.useArchiveCompression">
				<input type="checkbox" v-model="options.useArchivePassword" data-role="checkbox" :data-caption="$t('Protect archive file using password')" />
			</div>
			<div :disabled="!options.useArchiveCompression || !options.useArchivePassword" class="form-group">
				<label>{{ $t("Password") }}:</label>
				<input data-role="input" type="password" v-model.trim="options.archivePassword" :placeholder="$t('Enter Password')" data-prepend="<span class='mif-lock'></span>" :disabled="!options.useArchiveCompression || !options.useArchivePassword" />

				<!--Al momento c'è solo un tipo di protezione-->
				<!--<br />
                <label>{{ $t("Protection type") }}:</label>
                <br />
                <select class="input" v-model="options.protectionType"
                    :disabled="!options.useArchiveCompression || !options.useArchivePassword">
                    <option v-for="(value, index) in $root.selectValues.protectionTypes" :value="index"
                        v-bind:key="index">{{ $t(value) }}
                    </option>
                </select>-->

			</div>

		</div>
	</div>
</template>

<script>
import { FileSystemSidebarConfig } from "../../models/TreeNode";
import { fileExtensions } from "../../utils/objects";
import { isValid } from "../../utils/utilitiesmodule";

export default {
	name: "BackupSteps",
	props: {
		mainNodes: Array,
		options: Object,
		extensionsFilter: Boolean,
		fileSizeFilter: Boolean,
		exclusions: Boolean,
		zipCompression: Boolean,
		client: Object,
		type: Number
	},
	data() {
		return {
			useExtensionsFilter: false,
			fileExtensions: fileExtensions,

			specifiedExtensionsArray: [],

			mainNodeSelected: null,
			mainPath_exclNodes: {},

			fsSidebarConfig: null
		}
	},
	async mounted() {
		if (this.extensionsFilter) {
			this.useExtensionsFilter = this.options.specifiedExtensions != ""
			if (this.useExtensionsFilter) {
				this.specifiedExtensionsArray.update(this.options.specifiedExtensions.split(";"));
			}
		}

		if (!this.mainNodes)
			return;
		this.mainNodes.filter(n => !n.type.isFile()).forEach(mainNode => {
			this.mainPath_exclNodes[mainNode.path] = []
		});
		if (this.options.excludedPaths != "" && !this.options.excludedPaths.contains("{}")) {
			for (var [mainPath, exclNodes] of Object.entries(JSON.parse(this.options.excludedPaths))) {
				this.mainPath_exclNodes[mainPath].update(exclNodes);
				this.setExcludedNode(mainPath, exclNodes);
			}
		}
		//await waitSeconds(0.5);
	},
	beforeDestroy() {

		if (this.extensionsFilter) {

			if (this.useExtensionsFilter && this.specifiedExtensionsArray.length != 0) {
				this.options.specifiedExtensions = this.specifiedExtensionsArray.join(";");
			} else {
				this.options.specifiedExtensions = "";
			}
		}

		if (this.exclusions) {
			for (var [mainPath, excludedNodes] of Object.entries(this.mainPath_exclNodes)) {
				if (excludedNodes.length == 0) {
					delete this.mainPath_exclNodes[mainPath];
				}
			}
			this.options.excludedPaths = JSON.stringify(this.mainPath_exclNodes);
			if (this.options.excludedPaths == "\"{}\"") {
				this.options.excludedPaths = "{}";
			}
		}

		if (this.useArchiveCompression) {
			/*
			useArchiveCompression: false,

					useArchiveFileCustomName: false,
					archiveFileCustomName: "",

					useArchivePassword: false,
					archivePassword: "",

			*/

			if (!this.options.useArchiveCompression) {

				this.options.useArchiveFileCustomName = false;
				this.options.archiveFileCustomName = "";
				this.options.useArchivePassword = false;
				this.options.archivePassword = "";
			} else {
				if (this.options.useArchiveFileCustomName && this.options.archiveFileCustomName == "") {
					this.options.useArchiveFileCustomName = false;
				}

				if (!this.options.useArchiveFileCustomName && this.options.archiveFileCustomName != "") {
					this.options.archiveFileCustomName = "";
				}

				if (this.options.useArchivePassword && this.options.archivePassword == "") {
					this.options.archivePassword = false;
				}

				if (!this.options.useArchivePassword && this.options.archivePassword != "") {
					this.options.archivePassword = "";
				}

			}
		}


		this.$emit("sendOptions", this.options);
	},
	methods: {
		openFileSystemSidebarFrom() {

			if (this.mainNodeSelected.type.isFile()) {
				return;
			}


			this.$root.$off("sendSelectedNodes");

			var mainPath = this.mainNodeSelected.path.split("?")[0];
			if (this.fsSidebarConfig != null && this.fsSidebarConfig.rootPath != mainPath) {
				this.$root.$emit("closeFileSystemSidebar");
			}

			this.fsSidebarConfig = FileSystemSidebarConfig.get(
				this.type,
				true,
				0,
				null,
				mainPath,
				null,
				false
			);

			if (this.mainPath_exclNodes[mainPath] == undefined) {
				this.mainPath_exclNodes[mainPath] = [];
			}

			this.$root.$emit(
				"toggleFileSystemSidebar",
				this.mainPath_exclNodes[mainPath],
				//[],
				this.fsSidebarConfig
			);

			this.$root.$on("sendSelectedNodes", selectedNodes => {
				//this.$set(this.mainPath_exclNodes, node.path, selectedNodes);
				this.setExcludedNode(mainPath, selectedNodes)
				//this.$root.$off("sendSelectedNodes");
			});

		},

		setExcludedNode(mainPath, excludedNodes) {

			var mainNode_table = this.getHTMLNode("table", "mainNodePath", mainPath);
			if (mainNode_table) {
				if (excludedNodes.length == 0 && !mainNode_table.className.contains("d-none")) {
					mainNode_table.className += " d-none";
				}

				if (excludedNodes.length != 0 && mainNode_table.className.contains("d-none")) {
					mainNode_table.className = mainNode_table.className.replace("d-none", "");
				}
			}

			//this.mainPath_exclNodes[mainPath].update(excludedNodes);
			var mainNode_tbody = this.getHTMLNode("tbody", "mainNodePath", mainPath);
			console.debug(mainNode_tbody);
			//mainNode_tbody.innerText="";
			mainNode_tbody.innerHTML = "";
			//mainNode_tbody.html="";

			var html = "<tr class=\"d-flex my-1\" title=\"{0}\" >";
			html += "<td class='w-80'><span class=\"{1} px-2\"></span><span>... {2}</span></td>";
			html += "<td class='w-20'><span title=\"{0}\" class='mif-2x mif-bin ml-auto mr-2'></span></td>";
			html += "</tr>";
			var currentExcludedNode;
			excludedNodes.forEach(exclNode => {

				currentExcludedNode = this.getHTMLNode("tr", "title", exclNode.path);
				if (isValid(currentExcludedNode)) {
					return;
				}

				mainNode_tbody.innerHTML += html.format(
					exclNode.path,
					exclNode.type.getMetroIcon(exclNode.path),
					exclNode.path.lastPartOfPath()
				);

				setTimeout(() => {
					//this.getHTMLNode("span", "title", exclNode.path).on("click", () => this.uncheckNode(exclNode, mainPath));
					this.getHTMLNode("span", "title", exclNode.path).onclick = () => this.uncheckNode(exclNode, mainPath);
				}, 100);

			});

		},

		getHTMLNode(tag, prop, value) {
			try {
				var htmlNodes = $("{0}[{1}={2}]".format(tag, prop, value));
				if (htmlNodes.length != 0) {
					return htmlNodes[0];
				}

				const tag_allNodes = $(tag);
				htmlNodes = tag_allNodes.filter(x => x[prop.toLowerCase()] == value);
				if (htmlNodes.length != 0) {
					return htmlNodes[0];
				}

				htmlNodes = tag_allNodes.filter(x => x.attributes[prop.toLowerCase()] && x.attributes[prop.toLowerCase()].nodeValue == value);
				if (htmlNodes.length != 0) {
					return htmlNodes[0];
				}

				htmlNodes = tag_allNodes.filter(x => x[prop] == value);
				if (htmlNodes.length != 0) {
					return htmlNodes[0];
				}

				htmlNodes = tag_allNodes.filter(x => x.attributes.getNamedItem("nodeName") == prop.toLowerCase() && x.attributes.getNamedItem("value") == value);
				if (htmlNodes.length != 0) {
					return htmlNodes[0];
				}
			} catch { }
			return null;
		},

		uncheckNode(node, mainPath) {
			//rimuovo il check sulla sidebar
			this.$root.$emit('uncheckNode', node);

			if (mainPath == undefined) {
				return;
			}
			//Rimuovo il nodo html
			this.getHTMLNode("li", "title", node.path).remove();

			var indexOfExcludedNode = this.mainPath_exclNodes[mainPath].findIndex(n => n.path == node.path);
			if (indexOfExcludedNode != -1) {
				this.mainPath_exclNodes[mainPath].splice(indexOfExcludedNode, 1);
			}
		},
	}


}
</script>
